export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список ЭАД",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
